var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RbSpacer hSpace hSpace--app",class:_vm.elmClasses},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RbSpacer__inner"},[_c('br')])}]

export { render, staticRenderFns }